import { Component, input } from '@angular/core';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import {
  AnyChallenge,
  UnselectionButtonSecondVariantConfig,
} from '@shared/models';

import { UnselectionButtonBaseClass } from '../unselection-button.base.class';

@Component({
  selector: 'b2c-variant2',
  imports: [ElementDirective],
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
})
export class Variant2Component extends UnselectionButtonBaseClass {
  challenge = input.required<AnyChallenge>();
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
  config = input.required<UnselectionButtonSecondVariantConfig>();
}
